/**
 * ChangeJobsiteDiscardModal component for RMC Order Management
 * Warns users about losing order data when changing jobsite
 */

import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

interface ChangeJobSiteDiscardModalProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ChangeJobSiteDiscardModal: React.FC<ChangeJobSiteDiscardModalProps> = ({
  open,
  onCancel,
  onConfirm
}) => {
  const {t} = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      data-test-id="change-jobsite-discard-modal"
    >
      <DialogTitle>
        {t('orderIntake.rmc.changeJobsite.discardTitle', 'Change jobsite?')}
      </DialogTitle>
      <DialogContent>
        {t(
          'orderIntake.rmc.changeJobsite.discardMessage',
          'Changing the jobsite will discard all your current order data and you will need to start over. Are you sure you want to continue?'
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="primary"
          variant="text"
          data-test-id="change-jobsite-cancel-button"
        >
          {t('orderIntake.rmc.changeJobsite.continueEditing', 'Continue editing')}
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          data-test-id="change-jobsite-confirm-button"
        >
          {t('orderIntake.rmc.changeJobsite.confirmChange', 'Change jobsite')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
